export const GET_CMS_FILES_PENDING = '[ADMIN][GET] get CMS Files pending';
export const GET_CMS_FILES_SUCCESS = '[ADMIN][GET] get CMS Files success';
export const GET_CMS_FILES_FAILURE = '[ADMIN][GET] get CMS Files failure';
export const GET_DOCUMENTS_PENDING = '[DOCUMENTS][GET] get Cases pending';
export const GET_CMS_DROPDOWNS_SUCCESS = '[ADMIN][DROPDOWNS] get CMS dropdowns success';
export const GET_CMS_UPLOAD_DROPDOWNS_SUCCESS = '[ADMIN][DROPDOWNS] get CMS upload dropdowns success';
export const GET_CMS_ERROR_MESSAGE = '[ADMIN][ERROR] get ERROR message';
export const CLEAR_CMS_ERROR_MESSAGE = '[ADMIN][ERROR] clear ERROR message';
export const SET_CMS_PACKAGE_ID = '[ADMIN][PACKAGE ID] set CMS package id';
export const SHOW_FILTER_MODAL = '[ADMIN][FILTERS] show filter modal';
export const GET_DROPDOWN_VALUES_FOR_FILE_CATEGORY = '[ADMIN][DROPDOWNS] get CMS values for file category';
export const RESET_CMS_STATE = '[ADMIN][RESET] clear the upload cms package store';
export const GET_POWERBI_DETAILS = '[POWERBI] Generate PowerBi report'
export const GET_POWERBI_DETAILS_FAILURE = '[POWERBI] Generate PowerBi report failure';
export const CLEAR_POWERBI='clear report';




// WEBPACK FOOTER //
// ./src/ui/features/Admin/state/adminTypes.js